import React, { useEffect, useState } from 'react';
import style from '../../../assets/styles/pagination.module.css';
interface PaginationProps {
  currentPage: number | string;
  // eslint-disable-next-line no-unused-vars
  setCurrentPage: (page: any) => void;
  limit: number;
  totalCount: number;
  offset: number;
  // eslint-disable-next-line no-unused-vars
  setOffset: (offset: number) => void;
  isLoading?: boolean; // <-- loader flag from parent
}

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  setCurrentPage,
  limit,
  totalCount,
  offset,
  setOffset,
  isLoading = false, // <-- loader flag from parent
}) => {
  const [tempPage, setTempPage] = useState(currentPage);

  // Update tempPage when page changes (e.g., clicking next/prev)
  useEffect(() => {
    setTempPage(currentPage);
  }, [currentPage]);

  // Only updates the temp input field
  const handlePageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newPage: number | string = Number(e.target.value);
    const maxPage = Math.ceil(totalCount / limit);

    if (isNaN(newPage) || newPage === 0) {
      newPage = '';
    } else if (newPage > maxPage) {
      newPage = maxPage;
    } else if (newPage < 1) {
      newPage = 1;
    }

    setTempPage(newPage); // <-- only update input, not API
  };

  // Commit page => this triggers API call
  const commitPage = () => {
    if (tempPage === '' || Number(tempPage) < 1) {
      setCurrentPage(1);
    } else {
      setCurrentPage(Number(tempPage)); // <-- API triggers
    }
  };

  const handleBlur = () => {
    commitPage();
  };

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      commitPage();
    }
  };

  const next = () => {
    if (offset + limit >= totalCount) return;

    setOffset(offset + limit);
    setCurrentPage(Number(currentPage) + 1);
  };

  const previous = () => {
    if (offset - limit < 0) return;

    setOffset(offset - limit);
    setCurrentPage(Number(currentPage) - 1);
  };

  // Sync offset when page changes
  useEffect(() => {
    if (currentPage) {
      setOffset((Number(currentPage) - 1) * limit);
    }
  }, [currentPage, limit]);
  return (
    <div className={style.pagination}>
      {isLoading ? (
        <div />
      ) : (
        <React.Fragment>
          <div className={style.number}>
            The Page you are on &nbsp; &nbsp;
            <input
              type="number"
              className={style.currentpage}
              value={tempPage}
              onChange={handlePageChange}
              onBlur={handleBlur}
              onKeyDown={handleKeyDown}
            />
          </div>

          <div className={style.line}>
            <svg width="2" height="24" viewBox="0 0 2 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line
                opacity="0.1"
                x1="0.695312"
                y1="23.5"
                x2="0.695311"
                y2="0.5"
                stroke="#764FDB"
                strokeLinecap="round"
              />
            </svg>
          </div>

          <div className={style.change}>
            <button onClick={previous} disabled={offset === 0 || isLoading} className={style.changeButton}>
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M10.5622 12.7803C10.2635 13.0732 9.7793 13.0732 9.48064 12.7803L5.14685 8.53033C4.84819 8.23744 4.84819 7.76256 5.14685 7.46967L9.48064 3.21967C9.7793 2.92678 10.2635 2.92678 10.5622 3.21967C10.8608 3.51256 10.8608 3.98744 10.5622 4.28033L6.76921 8L10.5622 11.7197C10.8608 12.0126 10.8608 12.4874 10.5622 12.7803Z"
                  fill={offset === 0 ? '#e3e5e8' : '#00ABFB'}
                />
              </svg>
            </button>

            <div className={style.current}>
              {offset + 1}- {offset + limit > totalCount ? totalCount : offset + limit} of {totalCount}
            </div>

            <button onClick={next} disabled={offset + limit >= totalCount || isLoading} className={style.changeButton}>
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M6.63122 3.21967C6.92989 2.92678 7.41413 2.92678 7.7128 3.21967L12.0466 7.46967C12.3452 7.76256 12.3452 8.23744 12.0466 8.53033L7.7128 12.7803C7.41413 13.0732 6.92989 13.0732 6.63122 12.7803C6.33256 12.4874 6.33256 12.0126 6.63122 11.7197L10.4242 8L6.63122 4.28033C6.33256 3.98744 6.33256 3.51256 6.63122 3.21967Z"
                  fill={offset + limit >= totalCount ? '#e3e5e8' : '#00ABFB'}
                />
              </svg>
            </button>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};
export default Pagination;
